function r(n, e) {
  const t = n.key;
  for (; e; ) {
    if (e.key === t)
      return !0;
    e = e.parent;
  }
  return !1;
}
export {
  r as contains
};
